// extracted by mini-css-extract-plugin
export default {"main":"AuditLogsListBody_main__QmWon"};